import { Button, Modal } from "@design";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";

/** The consent asked before background sync runs on the user's Microsoft permissions (Content tab, chat cards). */
export function AutomatedSyncConsent({
  open,
  busy,
  onCancel,
  onAuthorize,
}: Readonly<{ open: boolean; busy: boolean; onCancel: () => void; onAuthorize: () => void }>) {
  const { t } = useTranslation("dataSources");
  return (
    <Modal
      open={open}
      onClose={() => !busy && onCancel()}
      title={t("sync.consentTitle")}
      actions={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            {t("content.cancel")}
          </Button>
          <Button variant="primary" loading={busy} onClick={onAuthorize}>
            {t("sync.authorize")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-3">
        <Text variant="body-sm" tone="secondary">
          {t("sync.consentBody1")}
        </Text>
        <Text variant="body-sm" tone="secondary">
          {t("sync.consentBody2")}
        </Text>
        <div className="flex items-start gap-2 rounded-lg bg-warning-subtle p-3">
          <AlertTriangle size={16} aria-hidden className="mt-0.5 shrink-0 text-warning-on-subtle" />
          <Text variant="caption" tone="warning">
            {t("sync.consentNote")}
          </Text>
        </div>
      </div>
    </Modal>
  );
}
